const getDefaultState = () => ({
  athletes: [],
  athletesDetailed: {},
  lastUpdate: null,
  lastUpdates: {}
})

export const state = getDefaultState

function getSlug (athlete) {
  return (athlete.name || '').toLowerCase().replace(/\s/g, '-').replace('-mbe', '').replace('-\'woodsy\'', '').replace('ö', 'o')
}

function getURL (athlete) {
  return `/pro-team/${getSlug(athlete)}`
}

export const mutations = {
  RESET (state) {
    Object.assign(state, getDefaultState())
  },
  SET_ATHLETES (state, athletes) {
    state.athletes = athletes.map((athlete) => {
      athlete.slug = getSlug(athlete)
      athlete.url = getURL(athlete)
      return athlete
    })
    state.lastUpdate = (new Date()).valueOf()
  },
  SET_ATHLETE (state, { id, data }) {
    data.slug = getSlug(data)
    data.url = getURL(data)

    state.athletesDetailed = { ...state.athletesDetailed, [id]: data }
    state.lastUpdates = { ...state.lastUpdates, [id]: (new Date()).valueOf() }
  }
}

export const getters = {
  athletes: state => state.athletes,
  athleteId: state => slug => (state.athletes.find(athlete => athlete.slug === slug) || {}).id,
  athlete: state => id => state.athletesDetailed[id],
  slug: state => athlete => getSlug(athlete),
  url: state => athlete => getURL(athlete)
}

export const actions = {
  async GET_ATHLETES ({ commit, state }) {
    // Persist data for 20 minutes
    if (state.lastUpdate && state.lastUpdate > (new Date()).valueOf() - 1000 * 60 * 20) return state.athletes

    try {
      const { data } = await this.$publicAPI.get('athletes/?limit=100', { useCache: true })
      commit('SET_ATHLETES', data.results)
      return data.results
    } catch (error) {
      this.app.$sentry.captureException(error)
    }
  },
  async GET_ATHLETE_BY_ID ({ commit, state }, id) {
    // Persist data for 20 minutes
    if (state.lastUpdate[id] && state.lastUpdate[id] > (new Date()).valueOf() - 1000 * 60 * 20) return
    
    try {
      const { data } = await this.$publicAPI.get(`athletes/${id}/`, { useCache: true })
      commit('SET_ATHLETE', { id, data })
    } catch (error) {
      this.app.$sentry.captureException(error)
    }
  }
}
